import { render, staticRenderFns } from "./newsaboutus.vue?vue&type=template&id=56afca68&scoped=true&"
import script from "./newsaboutus.vue?vue&type=script&lang=js&"
export * from "./newsaboutus.vue?vue&type=script&lang=js&"
import style0 from "./newsaboutus.vue?vue&type=style&index=0&id=56afca68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afca68",
  null
  
)

export default component.exports